module.exports = __webpack_public_path__ + "img/8b7b9729cacfb77004978cc48ab842dc.png";